<template>
  <div>
    <v-card
      flat
      width="100%"
    >
      <v-card
        class="d-flex justify-space-between mb-1 mt-1"
      >
        <v-card class="d-flex justify-center flex-grow-1" flat>
          <v-card flat class="pa-2">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              clearable
              :label="$t('message.common.mid')"
              v-model="search_mid"
            >
            </v-text-field>
          </v-card>
          <v-card flat class="pa-2">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              clearable
              :label="$t('message.common.title')"
              v-model="search_model"
            >
            </v-text-field>
          </v-card>
        </v-card>
        <v-card class="align-self-center mr-1" flat>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click="get_data('model', []);">
                mdi-refresh
              </v-icon>
            </template>
            <span>{{ $t("message.common.refresh") }}</span>
          </v-tooltip>
        </v-card>
      </v-card>
    </v-card>
    <v-data-table
      :value="selected_model"
      item-key="mid"
      :headers="model_headers"
      :items="model_data"
      :sort-by.sync="sort_by"
      :sort-desc.sync="sort_desc"
      must-sort
      class="elevation-1"
      :single-select="!multiple"
      :show-select="show_select"
      @input="show_select ? $emit('update_model_select', $event) : ''"
      @click:row="show_select ? '' : $emit('update_model_select', [$event])"
      :footer-props="{
        'items-per-page-options': [10, 100, 200, 500]
      }"
    >
      <template v-slot:header.data-table-select />
      <template v-slot:item.mid="{ item }">
        {{ item.mid }}
      </template>
      <template v-slot:item.name="{ item }">
        <template v-if="item.name.length <= 40">
          {{ item.name }}
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ item.name.substr(0, 40) }}...
              </span>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:item.field="{ item }">
        <FieldName
          :id="item.field"
          :source_lang="item.source_lang"
          :target_lang="item.target_lang"
          type="trainable"
        ></FieldName>
      </template>
      <template v-slot:item.direction="{ item }">
        {{ $t("message.common.lang_" + item.direction[0]) }}
        &rarr;
        {{ $t("message.common.lang_" + item.direction[1]) }}
      </template>
      <template v-slot:item.similarity="{ item }">
        <template v-if="item.similarity">
          {{ item.similarity.toFixed(1) }}
        </template>
        <template v-else>
          -
        </template>
      </template>
      <template v-slot:item.ctime="{ item }">
        {{ $d(1000 * item.ctime, 'long', $store.getters.langs[$i18n.locale].locale) }}
      </template>
      <template v-slot:item.operation="{ item }">
        <template v-if="
          mode === 'user'
          && operations.indexOf('translate_with_this') >= 0
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="$router.push('/translate?command_type=translate&model_type=model&model=' + item.mid + '&source_lang=' + item.source_lang + '&target_lang=' + item.target_lang)">
                mdi-translate
              </v-icon>
            </template>
            <span>{{ $t("message.model.translate_with_this") }}</span>
          </v-tooltip>
        </template>
        <template v-if="
          deletable(item)
          && operations.indexOf('delete') >= 0
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="confirm_delete_data(get_prefix() + 'model', [item.mid], get_id())">
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t("message.common.delete") }}</span>
          </v-tooltip>
        </template>
        <template v-if="
          operations.indexOf('preview') >= 0
        ">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ma-2" @click.stop="$refs.parallel_viewer && $refs.parallel_viewer.open(item.name, 'model', item.mid)">
                mdi-file-find
              </v-icon>
            </template>
            <span>{{ $t("message.viewer.preview") }}</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:footer.prepend>
        <v-card v-if="multiple" flat class="pl-3">
          {{ $t("message.common.selecting", { cur: selected_model.length, max: max_select }) }}
          <template v-if="select_one && selected_model.length < 1">
            <br />
            <span class="red--text">
              ({{ $t("message.common.select_one") }})
            </span>
          </template>
          <template v-if="selected_model.length > max_select">
            <br />
            <span class="red--text">
              ({{ $t("message.common.over_selecting", { max: max_select }) }})
            </span>
          </template>
        </v-card>
      </template>
    </v-data-table>
    <ParallelViewer
      ref="parallel_viewer"
      :mode="mode"
    ></ParallelViewer>
    <Confirm
      ref="delete_confirm"
      :message="$t('message.common.delete_confirm')"
      :positive="$t('message.common.yes')"
      :negative="$t('message.common.no')"
    >
    </Confirm>
    <v-overlay
      :absolute="true"
      :value="progress_overlay"
    >
      <v-progress-circular
        :value="progress"
      >
        {{ progress }}
      </v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import FieldName from '../components/FieldName';
import ParallelViewer from '../components/ParallelViewer';
import Confirm from '../components/Confirm';
import { res_list } from "../js/res_list";
import { http_error } from "../js/http_error";

export default {
  name: 'model_select',
  components: {
    FieldName,
    ParallelViewer,
    Confirm
  },
  mixins: [
    res_list,
    http_error
  ],
  props: {
    selected_model: Array,
    source_lang: String,
    target_lang: String,
    multiple: Boolean,
    select_one: Boolean,
    max_select: Number,
    show_select: Boolean,
    initital_mid: String,
    mode: String,
    operations: {
      type: Array,
      default: () => { return ['preview']; }
    },
    file_remarks: Object
  },
  data: function(){
    return {
      module_id: "75",
      data: [],
      progress: 0,
      progress_overlay: false,
      search_mid: "",
      search_model: "",
      sort_by: ['ctime'],
      sort_desc: [true]
    }
  },
  mounted: function(){
    this.search_mid = this.initital_mid;
    this.get_data("model", []);
  },
  computed: {
    model_data: function() {
      var result = [];
      for(var model of this.data){
        model["direction"] = [model.source_lang, model.target_lang];
        if(this.file_remarks
          && this.file_remarks.similarity){
          if(model.mid in this.file_remarks.similarity){
            model.similarity = this.file_remarks.similarity[model.mid].score;
          }else{
            model.similarity = null;
          }
        }
        result.push(model);
      }
      return result;
    },
    model_headers: function() {
      var headers = [
        {
          text: this.$i18n.t("message.common.mid"),
          value: 'mid',
          filter: value => {
            if(this.search_mid === "" || this.search_mid === null){
              return true;
            }
            return value.indexOf(this.search_mid) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.common.title"),
          value: 'name',
          filter: value => {
            if(this.search_model === "" || this.search_model === null){
              return true;
            }
            return value.indexOf(this.search_model) !== -1;
          }
        },
        {
          text: this.$i18n.t("message.common.base_model"),
          value: 'field'
        },
        {
          text: this.$i18n.t("message.common.direction"),
          value: 'direction',
          filter: (value) => {
            if(!this.source_lang || !this.target_lang){
              return true;
            }
            return value[0] === this.source_lang && value[1] === this.target_lang;
          }
        }
      ];
      if(this.similarity_header){
        headers.push({
          text: this.$i18n.t("message.common.similarity"),
          value: 'similarity',
        });
      }
      headers.push(
        { text: this.$i18n.t("message.common.ctime"), value: 'ctime' },
        {
          text: this.$i18n.t("message.common.operation"),
          value: 'operation',
          sortable: false
        }
      );
      return headers;
    },
    similarity_header: function(){
      return this.file_remarks
        && this.file_remarks.similarity
        && this.model_data.some((d) => {
          return d.similarity
            && (!this.source_lang || d.source_lang === this.source_lang)
            && (!this.target_lang || d.target_lang === this.target_lang);
        });
    }
  },
  watch: {
    similarity_header: function(newVal, oldVal){
      if(newVal){
        if(this.sort_by.length > 0
          && this.sort_desc.length > 0){
          this.sort_by[0] = "similarity";
          this.sort_desc[0] = true;
        }
      }else{
        if(this.sort_by.length > 0
          && this.sort_desc.length > 0){
          this.sort_by[0] = "ctime";
          this.sort_desc[0] = true;
        }
      }
    }
  }
}
</script>
